(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fee', {
            parent: 'entity',
            url: '/fee',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee/fees.html',
                    controller: 'FeeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fee-detail', {
            parent: 'fee',
            url: '/fee/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee/fee-detail.html',
                    controller: 'FeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Fee', function($stateParams, Fee) {
                    return Fee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'fee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('fee-detail.edit', {
            parent: 'fee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-dialog.html',
                    controller: 'FeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee', function(Fee) {
                            return Fee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee.new', {
            parent: 'fee',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-dialog.html',
                    controller: 'FeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fee: null,
                                valore: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fee', null, { reload: 'fee' });
                }, function() {
                    $state.go('fee');
                });
            }]
        })
        .state('fee.edit', {
            parent: 'fee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-dialog.html',
                    controller: 'FeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee', function(Fee) {
                            return Fee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee', null, { reload: 'fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee.delete', {
            parent: 'fee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee/fee-delete-dialog.html',
                    controller: 'FeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Fee', function(Fee) {
                            return Fee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee', null, { reload: 'fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
